import { type QueryClient } from '@tanstack/vue-query';

import { keys } from '../../keys';

export const handleUserChangeSuccess
  = (queryClient: QueryClient) => () => queryClient
    .invalidateQueries({ queryKey: keys.users.users.queryKey });
